import { ToastContainer, toast } from 'react-toastify';
import { useState } from 'react';
import { Cookies } from 'react-cookie';
import { useEffect, useRef } from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Loader from '../../Layout/Loader';
import { ClearSession } from '../../Common/Common'
import { useNavigate } from 'react-router-dom';
import Footer from '../../Layout/FooterComponent';

const cookies = new Cookies();
function ResetPassword({ open }) {
    useEffect(() => {
        document.title = 'Reset Password'
    }, [])
    const [resetPasswordData, setResetPasswordData] = useState({NewPassword: '', ConfirmPassword: '' });
    const [UserCodeValue, SetUserCodeValue] = useState('');
    const [SessionClear, SetSessionClear] = useState(false);
    const [resetPasswordAutoComplete, setResetPasswordAutoComplete] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const Token = cookies.get('token');
    const LoginUserCode = cookies.get('loginUserCode');
    const Source = 'web'
    const inputRefs = useRef([]);
    const navigate = useNavigate()

    const UserOption = [];
    for (let i = 0; i < resetPasswordAutoComplete.length; i++) {
        UserOption.push(resetPasswordAutoComplete[i].values);
    };
    const handleSubmit = async (event) => {
        event.preventDefault();
        const data = {
            ...resetPasswordData,
            Token,
            LoginUserCode,
            Source,
            UserCode:UserCodeValue,
        }
        setIsLoading(true)
        await fetch(`/api/User/ResetPassword`, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json"
            },
        }).then(async (response) => {
            const res = await response.json();
            if (res.status === 'SUCCESS') {
                toast.success(res.message, {
                    position: 'top-center'
                })
                handleReset();
                setIsLoading(false);
            }
            else if (res.message === "EXPIRED") {
                SetSessionClear(true);
                ClearSession();
            }
            else if (res.message !==""){
                toast.error(res.message, {
                    position: 'top-center'
                })
                inputRefs.current[res.focus].focus()
                inputRefs.current[res.focus].children[0].children[0].focus()

                setIsLoading(false)
            }
        }).catch((err) => {
            toast.error(err, {
                position: 'top-center'
            })
            setIsLoading(false)
        })
    };

    const handleReset = () => {
        setResetPasswordData({ ...resetPasswordData, NewPassword: '', ConfirmPassword: '' })
        SetUserCodeValue('');
    }

    const GetResetPasswordAutoCompleteList = async () => {
        let Type = 'GetUserCode';
        let ContextKey = '';
        let ContextKey2 = '';
        let Prefix = ".";
        let data = { Token, LoginUserCode, Type, Prefix, ContextKey, ContextKey2 }

        await fetch('/api/AutoComplete/AutoComplete',
            {
                method: 'POST',
                body: JSON.stringify(data),
                headers: {
                    "Content-Type": "application/json"
                }
            }).then(async (response) => {
                let res = await response.json()
                if (res.status === "SUCCESS") {
                    setResetPasswordAutoComplete(res.autoCompleteData);
                }
                else if (res.message === "EXPIRED") {
                    navigate("/login")
                    SetSessionClear(true);
                }
                else if (res.message !== "") {
                    toast.error(res.message, {
                        position: 'top-center',
                    })
                }  
            }).catch((err) => {
                toast.error(err, {
                    position: 'top-center',
                })
            });
    }

    useEffect(() => {
    
        GetResetPasswordAutoCompleteList();
    }, [])

    return (
        <main id="main" className="main" style={open ? {} : { marginLeft: "0" }}>
            <section className="section dashboard">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="content-box">
                            <div className="heading-box">
                                <div className="heading">
                                    <h6 className="m-0 font-weight-bold text-primary">{'Reset Password'}</h6>
                                </div>
                            </div>
                            <div className="form-box service-content-area ">
                                <div className="w-100 row gap-2 py-2">
                                    <div className="col-lg-4 col-md-6 col-sm-12 px-2 mx-4" >
                                        <div className="fields">
                                            <label className="form-label">User Code <span className="Required">*</span></label>
                                            <Autocomplete
                                                inputValue={UserCodeValue}
                                                onInputChange={(e, newInputValue) => {
                                                    SetUserCodeValue(newInputValue)
                                                }}
                                                options={UserOption}
                                                disablePortal
                                                freeSolo
                                                autoComplete
                                                renderInput={(params) => <TextField {...params}
                                                    className="form-control"
                                                    maxLength='100'
                                                    placeholder='User Name'
                                                    onKeyDown={(e) => {
                                                        if (e.key === 'Enter') {
                                                            inputRefs.current['txtNewPassword'].focus();
                                                        };
                                                    }}

                                                    ref={ref => (inputRefs.current['txtUserCode'] = ref)}

                                                />}
                                            />
                                           
                                        </div>
                                        <div className="fields">
                                            <label className="form-label">New Password <span className="Required">*</span></label>
                                            <input
                                                ref={ref => (inputRefs.current['txtNewPassword'] = ref)}
                                                maxLength='15'
                                                minLength='8'
                                                type="password"
                                                placeholder='New Password'
                                                className="form-control"
                                                autoComplete="off"
                                                value={resetPasswordData.NewPassword}
                                                onChange={(e) => setResetPasswordData({ ...resetPasswordData, NewPassword: e.target.value })}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        inputRefs.current['txtConfirmPassword'].focus();
                                                    };
                                                }}
                                            />
                                        </div>
                                        <div className="fields">
                                            <label className="form-label">Confirm Password <span className="Required">*</span></label>
                                            <input
                                                ref={ref => (inputRefs.current['txtConfirmPassword'] = ref)}
                                                maxLength='15'
                                                minLength='8'
                                                type="password"
                                                className="form-control"
                                                placeholder='Confirm Password'
                                                autoComplete="off"
                                                name='oldPassword'
                                                value={resetPasswordData.ConfirmPassword}
                                                onChange={(e) => setResetPasswordData({ ...resetPasswordData, ConfirmPassword: e.target.value })}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        handleSubmit(e)
                                                    };
                                                }}
                                            />
                                        </div>
                                        <div className="col-lg-12">
                                            <div className="lms-new-button text-center">
                                                <button className="button save-btn" onClick={handleSubmit}>
                                                    <i className="bi bi-check-lg" /> Reset Password
                                                </button>
                                                <button className="button reset-btn" onClick={handleReset}>
                                                    <i className="bi bi-arrow-clockwise" />Reset
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-lg-6 col-md-6 col-sm-12  password-policy-border  border border-1 p-0 mx-4 my-sm-2'>
                                        <div className='w-100 py-2 password-policy px-3'>
                                            <h6 className="m-0 font-weight-bold text-white">{'Password Policy'}</h6>
                                        </div>
                                        <div className='p-4'>
                                            <div className="form-group px-2">
                                                <li>White spaces are not allowed.</li>
                                                <li>Password must be between 8 to 15 character(s).</li>
                                                <li>Password must be combination of atleast one numeric and one upper case letter and Special character [@@$#!() ], white spaces are not allowed.</li>
                                                <li>New password and confirm password must be same.</li>
                                                <li>Old password and New password should be different.</li>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <ToastContainer theme='colored' />
            {isLoading ? <Loader text='Please wait' size='100px' img_path='./assets/img/giphy.gif' /> : <></>}
            {SessionClear ? <ClearSession /> : <></>}
            <Footer/>
        </main>
    );
}
export default ResetPassword;